import React from "react";
import PropTypes from "prop-types";
import {Field, reduxForm} from "redux-form";
import {connect} from "react-redux";

import {CheckboxField, InputField,} from "../../../NTICore/component/Form/InputField";
import SignatureContainer from "../../../NTICore/component/Signature/container/SignatureContainer";
import {ClipLoader} from "react-spinners";
import {CommitmentDescription} from "./CommitmentDescription";
import {CommitmentRules} from "./CommitmentRules";
import {FooterPage} from "../../../AppCore/Component/Layout/FooterPage";
import styles from "../../assets/css/page.css";

let Commitment = ({
  handleSubmit,
  submitForm,
  disabledSubmit,
  apiMessage,
                    showRequiredSignMessage, processingForm, Alert
}) => {
  return (
    <React.Fragment>
      <CommitmentDescription />
      <CommitmentRules />
      <div className="row" style={{marginBottom: '65px'}}>
        <div className="col-lg-3 col-sm-3 col-xs-3" />

        <div className="col-lg-6 col-sm-12 col-xs-12">
          <div className="widget flat">
            <div
              className="widget-body"
              style={{ backgroundColor: "transparent" }}
            >
              <div className="form-group">
                <label className="col-sm-12" style={{ padding: "inherit" }}>
                  Email *
                </label>
                <span className="input-icon icon-right">
                  <Field
                    name="email"
                    component={InputField}
                    label="Email"
                    placeholder="Email"
                    customClass="form-control input-sm"
                    autoComplete={"disabled"}
                    disabled={true}
                  />
                  <i className="glyphicon glyphicon-envelope" />
                </span>
              </div>
              <div className="form-group">
                <div className="checkbox">
                  <label>
                    <Field name="agree" component={CheckboxField} />
                  </label>
                  <span className={styles.termsAndConditionsText}>
                    I agree with the partner commitment and look forward to
                    start our relationship with GreenLink.
                  </span>
                </div>
              </div>
              <div id="registration-form">
                <form className="form-horizontal text-center">
                  <div className="form-title text-left">Please sign:</div>
                  {/* Signature Component from NTICore */}
                  <SignatureContainer />

                  {
                    showRequiredSignMessage ?
                      <span className="requiredSign">
                    To complete the process, please sign and click the button below.
                  </span> : null
                  }

                  <div className="btn-div" style={{marginTop: '10px'}}>
                    <p>
                      <button
                        className={`btn btn-success`}
                        onClick={handleSubmit(submitForm)}
                        disabled={disabledSubmit}
                      >
                        Sign
                      </button>
                    </p>
                  </div>

                  <div className="loader-div">
                    <ClipLoader size={35} color={"#444544"} loading={processingForm} />
                  </div>
                  {
                    apiMessage.length > 0 && <span className="requiredSign">{apiMessage}</span>
                  }
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={`row ${styles.footer}`}>
        <div className={"col-sm-12"}>
          <FooterPage />
        </div>
      </div>
    </React.Fragment>
  );
};

/** Allowed Props */
Commitment.propTypes = {
  submitForm: PropTypes.func.isRequired,
};

/** Specifies the default values for props: */
Commitment.defaultProps = {
  showRequiredSignMessage: false,
  apiMessage: "",
};

Commitment = reduxForm({
  form: "commitmentForm",
  // Obtain the ability to reset the initial values
  // Has conflict with update related models
  enableReinitialize: true,
  //onSubmitSuccess: afterSubmit
})(Commitment);

// You have to connect() to any reducers that you wish to connect to yourself
Commitment = connect((state) => ({
  initialValues: state.PartnerAgreementReducer.commitment, // pull initial values from delivery reducer
}))(Commitment);

export default Commitment;



// WEBPACK FOOTER //
// ./src/modules/PartnerAgreement/Component/Commitment/Commitment.js